import { render, staticRenderFns } from "./ModalStaffPermissions.vue?vue&type=template&id=a3e66ca4&scoped=true&"
import script from "./ModalStaffPermissions.vue?vue&type=script&lang=js&"
export * from "./ModalStaffPermissions.vue?vue&type=script&lang=js&"
import style0 from "./ModalStaffPermissions.vue?vue&type=style&index=0&id=a3e66ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e66ca4",
  null
  
)

export default component.exports